import { render, staticRenderFns } from "./Network.vue?vue&type=template&id=f840313c&scoped=true"
import script from "./Network.vue?vue&type=script&lang=js"
export * from "./Network.vue?vue&type=script&lang=js"
import style0 from "./Network.vue?vue&type=style&index=0&id=f840313c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f840313c",
  null
  
)

export default component.exports